(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benu__cart-drawer"]) return;
  try {
    
window.BenuShop.M.initCartDrawer();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benu__delivery-options"]) return;
  try {
    
const btnContinue = document.querySelector("button#checkout");
const checkoutForm = btnContinue?.closest("form");
checkoutForm?.addEventListener("submit", (event) => {
	const form = event.currentTarget;
	if (form.dataset.submitting === "true") {
		event.preventDefault();
		return;
	}

	form.dataset.submitting = "true";
	btnContinue.setAttribute("aria-busy", "true");
});

document.addEventListener("after.init.checkout.event.shopify.deliverygateway.io", () => {
	// enable continue button once a delivery option has been selected
	if(btnContinue){
		btnContinue.disabled = false;
	}
});

  } catch(e) { console.error(e); }
})();
})();
